import script from "./SubmitRequestPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmitRequestPage.vue?vue&type=script&setup=true&lang=js"

import "./SubmitRequestPage.vue?vue&type=style&index=0&id=121325a4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-121325a4"]])

export default __exports__